module.exports = __webpack_public_path__ + "img/fidc-bg-3.a970da73.png";